<template>
	<div>
		<div
			v-if="isRectangle"
			class="pos-rel rectangle-preview"
			:class="{ 'upload-border': !imageSrcValue }"
			:style="{
				width: width ? width : '150px',
				height: height ? height : '150px'
			}"
		>
			<img :src="_getImageSrc(imageSrcValue)" class="fill-height" alt />
			<label class="full-cover">
				<input
					@change="uploadImage"
					type="file"
					name="photo"
					accept="image/*"
					hidden
				/>
			</label>
			<div
				v-show="isLoading"
				class="container fill-height full-cover grey lighten-4"
				:class="{ 'br-circle': !isTile }"
			>
				<v-layout justify-center align-center>
					<v-progress-circular
						indeterminate
						v-bind:size="30"
						color="green"
					></v-progress-circular>
				</v-layout>
			</div>
		</div>
		<v-avatar
			v-else
			:size="`${avatarSize || '150px'}`"
			class="pos-rel grey lighten-4 cursor--pointer"
			:tile="isTile"
			@mouseover="showOptions = true"
			@mouseleave="showOptions = false"
		>
			<img
				:src="_getImageSrc(imageSrcValue)"
				alt
				:class="{ 'upload-border': !imageSrcValue }"
				class="contain"
			/>
			<label class="full-cover cursor--pointer">
				<input
					ref="fileExplorer"
					@change="uploadImage"
					type="file"
					name="photo"
					accept="image/*"
					hidden
				/>
			</label>
			<v-layout
				class="full-cover grey lighten-2 op-2 allCenteredChild"
				v-if="showOptions && imageSrcValue"
			>
				<v-flex class="no-flex-grow">
					<v-btn small flat icon @click="openFileExplorer">
						<v-icon size="22">edit</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="vertical-divider no-flex-grow"></v-flex>
				<v-flex class="no-flex-grow">
					<v-btn small icon @click="showFullImageDialog = true">
						<v-icon size="22">visibility</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
			<div
				v-show="isLoading"
				class="container fill-height full-cover grey lighten-4"
				:class="{ 'br-circle': !isTile }"
			>
				<v-layout justify-center align-center>
					<v-progress-circular
						indeterminate
						v-bind:size="30"
						color="green"
					></v-progress-circular>
				</v-layout>
			</div>
		</v-avatar>
		<v-layout row wrap v-if="showDiscard">
			<v-flex xs12 class="text-xs-center mt-4">Changed your mind?</v-flex>
			<v-flex xs12 class="text-xs-center mt-0">
				<!-- <input :ref="refType" type="file" accept="video/*" @change="onFileChange" hidden/> -->
				<v-btn
					flat
					:disabled="isLoading"
					color="green"
					@click="resetMedia"
					>Discard</v-btn
				>
			</v-flex>
		</v-layout>
		<v-dialog v-model="showFullImageDialog" max-width="600">
			<v-card>
				<img :src="imageSrcValue" class="d-block full-width" />
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import placeholderImage from "@/assets/thumbnail.jpeg";

import { UPLOAD_MEDIA_TO_SERVER } from "@/store/action-types";
export default {
	name: "ImagePreview",
	props: [
		"imageSrcValue",
		"isTile",
		"uploadKey",
		"avatarSize",
		"isRectangle",
		"width",
		"height",
		"showDiscard",
		"returnDataUri"
	],
	data() {
		return {
			placeholderImage,
			showOptions: false,
			showFullImageDialog: false,
			isLoading: false
		};
	},
	methods: {
		openFileExplorer() {
			this.$refs.fileExplorer.click();
		},
		_getImageSrc(str) {
			return str || placeholderImage;
		},
		uploadImage(e) {
			let files = e.target.files;
			if (!files[0]) {
				return;
			}
			if (this.returnDataUri) {
				this.$emit("UPDATE_UPLOAD_VALUES", {
					key: this.uploadKey,
					file: files[0]
				});
				return;
			}

			if (!this.isLoading) {
				this.isLoading = true;
				this.$store
					.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
						key: this.uploadKey,
						file: files[0],
						type: "imageUpload"
					})
					.catch(() => {})
					.then(() => {
						// debugger;
						this.isLoading = false;
					});
			}

			e.target.value = "";
		},
		resetMedia() {
			this.$emit("RESET_MEDIA");
		}
	}
};
</script>
<style>
.rectangle-preview {
	text-align: center;
	background-color: #eaeaea;
}
.upload-border {
	border: 3px dashed #bdbdbd;
}
.vertical-divider {
	width: 1px;
	height: 50%;
	background: #a79e9e;
}
</style>
